/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { flatten, get } from 'lodash';
import { Tooltip, Typography } from 'antd';
import { Country } from 'react-phone-number-input/input';
import { reactJoin } from '../../../util/reactJoin';
import ContactLink from '../../../components/Badge/ContactLink';
import { personFieldConfig } from './utils/personFieldsUtils';
import { Locale } from '../../../../localization/LocalizationKeys';

export const linksContactInformationFieldConfig = personFieldConfig(
  'linksContactInformation',
  [
    'id',
    'countryCode',
    'linksContactInformation(typeCodes:["EMAIL"]).entityAffiliationId',
    'linksContactInformation(typeCodes:["EMAIL"]).entityType',
    'linksContactInformation(typeCodes:["EMAIL"]).contactType.code',
    'linksContactInformation(typeCodes:["EMAIL"]).contactType.enum',
    'linksContactInformation(typeCodes:["EMAIL"]).values.id',
    'linksContactInformation(typeCodes:["EMAIL"]).values.value',
    'linksContactInformation(typeCodes:["EMAIL"]).values.category.code',
    'linksContactInformation(typeCodes:["EMAIL"]).values.category.heading',
    'linksContactInformation(typeCodes:["EMAIL"]).values.category.typeEnum',
    'linksContactInformation(typeCodes:["EMAIL"]).values.consent.status',
  ],
  ({ localization }) => ({
    title: localization.formatMessage(Locale.Text.Link_Email),
    additionalTableConfig: {
      width: 200,
    },
    
    render: (record) => {
      const countryCode = get(record, 'countryCode');

      const data = record.linksContactInformation ?? [];
      const emails = flatten((data ?? []).map((c: any) => Array.isArray(c?.values) ? c.values : []));

      if (!emails.length) return null;

      const contactField = reactJoin(
        emails.map((value: any) => (
          <ContactLink
            key={value.id}
            consent={value?.consent?.status}
            value={value?.value ?? ''}
            type={value?.category?.typeEnum ?? 'EMAIL'}
            categoryName={value?.category?.heading ?? 'Email'}
            countryCode={countryCode as Country}
          />
        )),
      );

      return (
        <Typography.Paragraph
          style={{ marginBottom: 0 }}
          ellipsis={{ rows: 1 }}
        >
          <Tooltip placement="left" title={contactField}>
            {contactField}
          </Tooltip>
        </Typography.Paragraph>
      );
    },

    preserve: true,
  }),
);
